import React, { useState,} from "react";
import { StyleSheet, TouchableOpacity, Text } from 'react-native';

import { View } from '../../../components/Themed';
import { Entypo, FontAwesome, Ionicons, MaterialCommunityIcons } from '@expo/vector-icons';
import Utilities from "../~Utilities/Utilities";
import { FontInfo } from "../~Utilities/Constants";
//import Order from "../C_Popups/SettingsAndOrders";

/*   -------------------------------------------------------------------   */

const DEF_WIDTH         = 300;

/*   -------------------------------------------------------------------   */

export interface IDotOrderInfo
{
  clickEvent     : (iIndex: number)=>void;
  submitEvent?   : ()=>void;
  iIndex         : number;
  is_buy?        : boolean;
  is_opt_enabled : boolean | undefined;
  is_bkt_enabled : boolean | undefined;
}

/*   ====================================================================   */

export default class DotsOrder extends React.Component<IDotOrderInfo>
  {
  // const [m_index, setIndex]               = useState(iIndex);

  /*   -------------------------------------------------------------------   */

  public static readonly PAGE_ORDER             = 0;
  public static readonly PAGE_OPTIONS           = 1;
  public static readonly PAGE_BRACKET           = 2;

  /*   -------------------------------------------------------------------   */

  state = {m_index : 0, };

  /*   -------------------------------------------------------------------   */

  constructor(props)
  {
  super(props);

  this.state          = {m_index: this.props.iIndex, };
  this.SetIndex       = this.SetIndex.bind(this);
  this.SetIndexForce  = this.SetIndexForce.bind(this);

  
  }

/*   -------------------------------------------------------------------   */

 SetIndex(iIndex : number)
 {
 if (this.state.m_index != iIndex)
    {
    this.setState({m_index : iIndex});
    Utilities.Sendlog("page: " + iIndex);

    //this.props.onBlue(this.state.m_index);
  
    //alert(iIndex);
    return(true);
    }

 return(false);    
 }

 /*   --------------------------------------------------------------------   */

  SetIndexForce(iIndex : number)
 {
  this.setState({m_index : iIndex});
  this.forceUpdate();
 }

 /*   --------------------------------------------------------------------   */

  render()
  {
    return(
      <View style={{flexDirection:'column', alignSelf:'center', backgroundColor:'transparent'}}>

      <View style={{backgroundColor:FontInfo.sBackgroundTp, 
                     width:DEF_WIDTH, borderBottomStartRadius:20, borderBottomEndRadius:20, }}>

      <View style={{flexDirection:'row', backgroundColor:'transparent', alignSelf:'center', }}>
      <TouchableOpacity style={styles.dot_cover} onPress={()=> {this.props.clickEvent(0)}}>
      <TouchableOpacity style={this.state.m_index == 0? 
                               [styles.dot_on, {backgroundColor: !this.props.submitEvent? FontInfo.sLightGreen : this.props.is_buy? 'dodgerblue' : 'hotpink'}]
                               : styles.dot_off} onPress={()=> {this.props.clickEvent(0)}} />
      </TouchableOpacity>

      <TouchableOpacity style={styles.dot_cover} onPress={()=> {this.props.clickEvent(1)}}>
        <TouchableOpacity style={this.state.m_index == 1? 
                                 [styles.dot_on, {backgroundColor: !this.props.submitEvent? FontInfo.sLightGreen : this.props.is_buy? 'dodgerblue' : 'hotpink'}]
                                 : styles.dot_off} onPress={()=> {this.props.clickEvent(1)}} />
      </TouchableOpacity>

      <TouchableOpacity style={styles.dot_cover} onPress={()=> {this.props.clickEvent(2)}}>
        <TouchableOpacity style={this.state.m_index == 2? 
                                 [styles.dot_on, {backgroundColor: !this.props.submitEvent? FontInfo.sLightGreen : this.props.is_buy? 'dodgerblue' : 'hotpink'}]
                                 : styles.dot_off} onPress={()=> {this.props.clickEvent(2)}}/>
      </TouchableOpacity>
      </View>
      </View>

      <View style={ {flexDirection:'row', marginTop:15, backgroundColor:'transparent', alignSelf:'center', }  }>

        {/* Settings */}
        <TouchableOpacity //activeOpacity={1.1}
          style={this.props.submitEvent? {display:'none'} : {backgroundColor: FontInfo.sBackgroundTp, 
                 borderWidth:2, borderColor:this.state.m_index==DotsOrder.PAGE_ORDER? 'rgba(3, 192, 74, .95)' : 'transparent',
                  //shadowColor:'rgba(30,144,255,.95)', shadowRadius:10, 
                  //borderColor:this.state.m_index == Order.PAGE_BRACKET? this.props.is_buy? 'rgba(30,144,255,.9)':'hotpink':'transparent', borderWidth:0,
                 margin:10, borderRadius:30, alignItems:'center', justifyContent:'center', height:60, width:60, }}
          onPress={()=>
            {
            this.props.clickEvent(DotsOrder.PAGE_ORDER);
            }}>

          <Ionicons name="md-settings-outline" size={24} color={FontInfo.sForeground} />
          {/* <MaterialCommunityIcons name="code-brackets" style={{}} size={24} color={this.props.is_bkt_enabled? '#03c04a' : FontInfo.sForeground} /> */}
        </TouchableOpacity>
        


          {/* Options */}
          <TouchableOpacity //activeOpacity={1.1}
              style={{backgroundColor:FontInfo.sBackgroundTp, 
                      // borderWidth:2, borderColor:this.state.m_index==DotsOrder.PAGE_OPTIONS? '#03c04a' : 'transparent',
                      borderWidth:2, borderColor:this.state.m_index==DotsOrder.PAGE_OPTIONS? !this.props.submitEvent? 'rgba(3, 192, 74, .95)' : this.props.is_buy? 'rgba(30,144,255,.95)' : 'rgba(255,105,180,.95)' : 'transparent',
                      margin:10, borderRadius:30, alignItems:'center', justifyContent:'center', height:60, width:60, }}
              onPress={()=>
                {
                this.props.clickEvent(DotsOrder.PAGE_OPTIONS);
                }}>

            <Ionicons name="options" size={24} color={this.props.is_opt_enabled? '#03c04a' : FontInfo.sForeground} />
          </TouchableOpacity>



          {/* <View style={{flexDirection:'column', backgroundColor:'transparent'}}> */}

           {/* Order */}
            <TouchableOpacity
            style={ !this.props.submitEvent? {display:'none'} :
                    [this.props.is_buy? {backgroundColor:FontInfo.bTransparency?'rgba(30,144,255,.95)':'rgba(30,144,255,1)', //dodgerblue
                                        alignSelf:'center', margin:10, borderRadius:45, alignItems:'center', 
                                          justifyContent:'center', minHeight:90, minWidth:90, } :
                                        {backgroundColor:FontInfo.bTransparency?'rgba(255,105,180,.95)':'rgba(255,105,180,1)', //hotpink
                                          alignSelf:'center', margin:10, borderRadius:45, alignItems:'center', 
                                          justifyContent:'center', minHeight:90, minWidth:90, }]}
            onPress={()=>
              {
                if (this.props.submitEvent) this.props.submitEvent();
              }}
              >
            <Text style= {this.props.is_buy? [FontInfo.appStyles.txt_bold, {minWidth:70, fontSize: FontInfo.iFontSize + 6, color:'white', textAlign:'center'}] :
                                              [FontInfo.appStyles.txt_bold, {minWidth:70, fontSize: FontInfo.iFontSize + 6, color:'white', textAlign:'center'}]
                          }>{this.props.is_buy? "Buy" : "Sell"}</Text>
            </TouchableOpacity>

            {/* <TouchableOpacity //activeOpacity={1.1}
            style={{backgroundColor:'transparent', margin:10, borderRadius:20, alignItems:'center', 
                    alignSelf:'center', justifyContent:'center', height:40, width:40, }}
            onPress={()=>
              {
                this.props.clickEvent(Order.PAGE_ORDER);
              }}>

            <FontAwesome name="circle" size={20} color={ this.state.m_index == Order.PAGE_ORDER? 
                                                        'cornflowerblue' : FontInfo.sForeground} />
            </TouchableOpacity> */}

          {/* </View> */}



        {/* Bracket */}
        <TouchableOpacity //activeOpacity={1.1}
          style={{backgroundColor: FontInfo.sBackgroundTp, 
                  // borderWidth:2, borderColor:this.state.m_index==DotsOrder.PAGE_BRACKET? '#03c04a' : 'transparent',
                  borderWidth:2, borderColor:this.state.m_index==DotsOrder.PAGE_BRACKET? !this.props.submitEvent? 'rgba(3, 192, 74, .95)' : this.props.is_buy? 'rgba(30,144,255,.95)' : 'rgba(255,105,180,.95)' : 'transparent',
                  //shadowColor:'rgba(30,144,255,.95)', shadowRadius:10, 
                  //borderColor:this.state.m_index == Order.PAGE_BRACKET? this.props.is_buy? 'rgba(30,144,255,.9)':'hotpink':'transparent', borderWidth:0,
                  margin:10, borderRadius:30, alignItems:'center', justifyContent:'center', height:60, width:60, }}
          onPress={()=>
            {
            this.props.clickEvent(DotsOrder.PAGE_BRACKET);
            }}>

          <MaterialCommunityIcons name="code-brackets" style={{}} size={24} color={this.props.is_bkt_enabled? '#03c04a' : FontInfo.sForeground} />
        </TouchableOpacity>


        </View>

        </View>

    );
  }
}

const styles = StyleSheet.create({
  dot_cover: 
  {
    margin:0, width:20, height:20, borderRadius:10, backgroundColor:'transparent', alignItems:'center', justifyContent:'center'
  },

  dot_on: 
  {
    margin:0, width:10, height:10, borderRadius:5, backgroundColor:FontInfo.sLightGreen
  },

  dot_off: 
  {
    margin:0, width:10, height:10, borderRadius:5, backgroundColor:FontInfo.sGray
  },
});